var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":_vm.logo,"width":"38"}}),(_vm.newYear)?_c('img',{staticClass:"position-absolute",staticStyle:{"transform":"rotateZ(18deg)","left":"20px","top":"-1px"},attrs:{"src":_vm.logoNewYear,"width":"42"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }